export default {
  /* --------------------------------- 新增@TODO -------------------------------- */
  create: '创建中',
  timeout: '支付超时',
  finish: '完成',
  /* --------------------------------- 新增@TODO -------------------------------- */
  open: '开启',
  close: '关闭',
  success: '成功',
  success1: '已支付',
  success2: '正常',
  success3: '通过',
  success4: '回调成功',
  success5: '支付成功',
  success6: '补单成功',
  errorafter: '补单',
  paying: '支付中',
  doing: '处理中',
  doing1: '申请中',
  doing2: '等待支付',
  doing3: '补单中',
  doing88: '手动补单',

  error: '失败',
  error1: '未支付',
  error2: '禁用',
  error3: '拒绝',
  error4: '未回调',
  error5: '回调失败',
  error6: '支付失败',
  error7: '补单失败',
  error8: '未补单',
  error9: '支付失败补单',
  error10: '回调失败补单',
  error11: '无效定单',
  error12: '无效定单',
  error13: '锁定',
  choose: '请先选择',
  worring: '此操作有风险, 是否继续?',
  tip: '提示',
  confor: '确定',
  Cancel: '取消',
  batchSuccess: '批量补单成功!',
  cancelOlder: '已取批量补单',
  toBeConfirmed: '待确认'
};



// WEBPACK FOOTER //
// ./src/i18n/lang/zh/status.js